import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISiteDetailsModel } from '@apps-common/types/portal/site-details'

export const QUERY_KEY_MY_MONITORING_GET_SITE_DETAILS = (unitId?: string) => ['getMyMonitoringSiteDetails', unitId].filter(Boolean)

const getSiteDetails = async (unitId: string): Promise<ISiteDetailsModel> =>
  axios.get(`/my-monitoring/sites/GetSiteDetails?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSiteDetails

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useMyMonitoringGetSiteDetails = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_DETAILS(unitId),
    queryFn: () => getSiteDetails(unitId)
  })
